import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const creditCardKeys = createQueryKeyStore({
  creditCard: {
    list: null,
    detail: (id) => [id],
    hasActiveReservations: (id: string, patientId: number) => [id, patientId],
  },
});
